var exports = {
  "$": "x31de4314--bc6af3--services",
};

module.exports = exports;
